export default "__VITE_ASSET__f8d5c45d__"